import axios from "./axios";
import { ApiResponse } from "../types/express-data.type";
import {
  ExpressCreditBillList,
  ExpressCreditBillParams,
  ExpressDocumentCancelRequest,
  ExpressDocumentDetail,
  ExpressDocumentList,
  ExpressDocumentListParams,
  ExpressDocumentRequest,
} from "../types/express-document.type";

const EXPRESS_DOCUMENTS_PATH = "/express-documents";

/**
 * A refusal on a save (a received amount that does not balance, an overpaid bill) is the
 * server's Thai message in the global toast; the form stays as keyed, so the 403 redirect is off.
 */
const WRITE_META = { suppressForbiddenRedirect: true };

const documentPath = (uuid: string) => `${EXPRESS_DOCUMENTS_PATH}/${encodeURIComponent(uuid)}`;

export const getExpressDocuments = (params: ExpressDocumentListParams) =>
  axios.get<ApiResponse<ExpressDocumentList>>(EXPRESS_DOCUMENTS_PATH, { params });

export const getExpressDocument = (uuid: string) =>
  axios.get<ApiResponse<ExpressDocumentDetail>>(documentPath(uuid));

export const createExpressDocument = (body: ExpressDocumentRequest) =>
  axios.post<ApiResponse<ExpressDocumentDetail>>(EXPRESS_DOCUMENTS_PATH, body, {
    meta: { ...WRITE_META, successMsg: "บันทึกเอกสารสำเร็จ" },
  });

export const updateExpressDocument = (uuid: string, body: ExpressDocumentRequest) =>
  axios.put<ApiResponse<ExpressDocumentDetail>>(documentPath(uuid), body, {
    meta: { ...WRITE_META, successMsg: "บันทึกการแก้ไขสำเร็จ" },
  });

/** The caller shows a refusal inside its own dialog, so the generic toast is suppressed. */
export const cancelExpressDocument = (uuid: string, body: ExpressDocumentCancelRequest) =>
  axios.post<ApiResponse<ExpressDocumentDetail>>(`${documentPath(uuid)}/cancel`, body, {
    meta: {
      successMsg: "ยกเลิกเอกสารสำเร็จ",
      suppressErrorToast: true,
      suppressForbiddenRedirect: true,
    },
  });

/** The customer's credit bills with something still outstanding, for an E1 receipt. */
export const getExpressCreditBills = (params: ExpressCreditBillParams) =>
  axios.get<ApiResponse<ExpressCreditBillList>>(`${EXPRESS_DOCUMENTS_PATH}/credit-bills`, {
    params,
    meta: { suppressErrorToast: true },
  });
